import React, { useContext } from "react";
import { Col, Row, Typography, Button } from "antd";
import { Link } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { COLORS } from "../../../constants";

import { TourOperatorContext } from "./context-view";
import { touroperatorInitialValues as initialValues } from "./initialvalues/initialValues";

const { Paragraph, Title } = Typography;

const NonPHResidentView = () => {
  const token = jwtDecode(localStorage.getItem("token"));
  const userType = token?.loginAs;

  let { pageData } = useContext(TourOperatorContext);
  const data = pageData?.data || initialValues;

  return (
    <>
      <Row gutter={10}>
        <Col span={12}> Origin(Country)</Col>
        <Col span={4}>
          <Paragraph level={4}> Male </Paragraph>
        </Col>
        <Col span={4}>
          <Paragraph level={4}> Female </Paragraph>
        </Col>
        <Col span={4}>
          <Paragraph level={4}> DTH </Paragraph>
        </Col>
      </Row>

      {data && data["nonPhResident"]?.length > 0 ? (
        data["nonPhResident"].map((items, index) => (
          <Row
            gutter={10}
            className={"row-darken"}
            justify="space-between"
            align="center"
          >
            <Col span={12}>{items?.["country"]}</Col>
            <Col span={4}>{items?.["male"] || 0}</Col>
            <Col span={4}>{items?.["female"] || 0}</Col>
            <Col span={4}>{items?.["durationHrs"] || 0}</Col>
          </Row>
        ))
      ) : (
        <Row className={"row-darken"} justify="center" align="center">
          <Title level={5}> Nothing to show here ...</Title>
        </Row>
      )}

      {userType !== "Administrator" && (
        <Row>
          <Col span={12}>
            <Button
              htmlType="reset"
              size="large"
              style={{ backgroundColor: COLORS.green }}
            >
              <Link
                to={`/v2/${userType}/tour-operator/${pageData?.transactionId}`}
                state={pageData}
              >
                EDIT
              </Link>
            </Button>
          </Col>
          <Col
            span={12}
            style={{ justifyContent: "flex-end", display: "flex" }}
          >
            <Button
              size="large"
              htmlType="submit"
              style={{ backgroundColor: COLORS.orange }}
            >
              <Link to={`/v2/${userType}/tour-operator`}>ADD REPORT</Link>
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default NonPHResidentView;
